import { createFileRoute } from '@tanstack/react-router'
import { ModuleDetailPage } from '@/features/classes/detail'

export const Route = createFileRoute(
  '/_authenticated/classes/detail/$classId/$moduleId'
)({
  component: ModuleDetailWrapper,
})

function ModuleDetailWrapper() {
  const { classId, moduleId } = Route.useParams() as { classId: string; moduleId: string }
  const search = Route.useSearch() as { tab?: string }
  return <ModuleDetailPage key={`${moduleId}-${classId}-${search?.tab ?? 'chapter'}`} initialTabKey={search?.tab} />
}

export default Route
